import { datadogRum } from '@datadog/browser-rum';

import { brand, env, getConfigValue, getCurrentCommitHash, platform } from 'utils/environment';

import { DD_RUM_SESSION_REPLAY_SAMPLE_RATE, DD_RUM_SESSION_SAMPLE_RATE } from './constants';

let isDatadogRumInitialized = false;

export const buildDatadogRumConfiguration = () => {
  const dataDogConfig = getConfigValue({ key: 'datadog', defaultValue: { rum: {} } });
  const awsConfig = getConfigValue({ key: 'aws', defaultValue: {} });

  const allowedTracingUrls = [awsConfig.gqlApiUrl, awsConfig.gqlGatewayApiUrl].filter(Boolean);

  return {
    applicationId: dataDogConfig.webRumApplicationId,
    clientToken: dataDogConfig.webClientToken,
    site: 'datadoghq.com' as const,
    service: `${brand()}_${platform()}`,
    env: env(),
    version: getCurrentCommitHash(),
    sessionSampleRate: DD_RUM_SESSION_SAMPLE_RATE,
    sessionReplaySampleRate: DD_RUM_SESSION_REPLAY_SAMPLE_RATE,
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
    trackViewsManually: true,
    enableExperimentalFeatures: ['feature_flags'],
    defaultPrivacyLevel: 'mask' as const,
    allowedTracingUrls,
  };
};

export const initDatadogRum = () => {
  if (isDatadogRumInitialized) {
    return Promise.resolve();
  }

  const config = buildDatadogRumConfiguration();

  if (!config.applicationId || !config.clientToken) {
    return Promise.resolve();
  }

  datadogRum.init(config);
  isDatadogRumInitialized = true;
  return Promise.resolve();
};

export const initDatadogLoggingAndMaybeRum = initDatadogRum;
